import { forwardRef, useMemo, useState } from "react";
import { Input, Select, SelectOption, SelectProps } from "rizzui";

type Props = Omit<SelectProps<SelectOption>, "options"> & {
  data: SelectOption[];
  searchPlaceholder?: string;
  value?: SelectOption;
};

const ProjectDataSelect = forwardRef<HTMLDivElement, Props>(
  (
    {
      data,
      onChange,
      placeholder,
      searchPlaceholder = "Search by name project",
      value = "",
      ...props
    },
    ref,
  ) => {
    const [search, setSearch] = useState("");

    const filteredOptions = useMemo(
      () =>
        data
          .filter((option) =>
            option.label.toLowerCase().includes(search.toLowerCase()),
          )
          .sort((a, b) => a.label.localeCompare(b.label)),
      [data, search],
    );

    const renderSearchInput = (option: SelectOption) => {
      if (option.value !== "search") {
        return option.label;
      }

      return (
        <div className="w-full p-2">
          <Input
            type="search"
            placeholder={searchPlaceholder}
            value={search}
            onClear={() => setSearch("")}
            onChange={(event) => setSearch(event.target.value)}
            rounded="lg"
            clearable
            className="w-full"
          />
        </div>
      );
    };

    return (
      <div ref={ref}>
        <Select
          {...props}
          options={[
            { label: "Search", value: "search", disabled: true },
            ...filteredOptions,
          ]}
          onChange={(selected) => {
            onChange?.(selected);
            setSearch("");
          }}
          optionClassName="first:bg-white first:p-0 first:sticky first:top-[-6px] first:[&>div]:w-full"
          getOptionDisplayValue={renderSearchInput}
          getOptionValue={(option) => option}
          displayValue={(selected: SelectOption) =>
            data.find((option) => option.value === selected?.value)?.label ??
            placeholder
          }
          placeholder={placeholder}
          value={value}
        />
      </div>
    );
  },
);

ProjectDataSelect.displayName = "ProjectDataSelect";

export default ProjectDataSelect;
